export  enum FormContext {
    SUBSECTION_FORM = 0,
    FORM_EDIT_TABLE = 1,
    FORM_EDIT_FORM = 2,
    SECTION_FORM = 3
}
